module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-33.4ff77f3f.png";